module.exports = __webpack_public_path__ + "img/viber_logo.5e2b1152.png";